module.exports = __webpack_public_path__ + "static/Chernomorsk-3871fd19bc7cd8887a22fa7fe9dfef8e.svg";